import { render, staticRenderFns } from "./loginForgot.vue?vue&type=template&id=2ff3b65c&scoped=true&"
import script from "./loginForgot.vue?vue&type=script&lang=js&"
export * from "./loginForgot.vue?vue&type=script&lang=js&"
import style0 from "./loginForgot.vue?vue&type=style&index=0&id=2ff3b65c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff3b65c",
  null
  
)

export default component.exports